import Vue from 'vue';
import CsmlMonacoEditor from '@clevy/vue-csml-monaco';

Vue.use(CsmlMonacoEditor);